<template>
  <div :class="name" class="video-container">
    <video
      v-if="(cms.video || {}).filename"
      ref="videoPlayer"
      preload="none"
      playsinline
      loop
      muted
      :class="`${name}__video`"
      :poster="cms.image.filename"
      @click="togglePlay"
    >
      <source
        :src="cms.video.filename"
        type="video/mp4"
        :class="`${name}__video`"
      />
    </video>
    <youtube
      v-else-if="(cms.youtube || {}).vimeo_raw"
      :video-id="youTubeId"
      host="https://www.youtube.com"
      :class="[`${name}__video`, `${name}__video--youtube`]"
      @playing="onShowContent(false)"
      @paused="onShowContent(true)"
      @ready="onEmbeddedVideoReady()"
    />
    <vimeo-player
      v-else-if="(cms.vimeo || {}).vimeo_raw"
      :video-id="vimeoId"
      :class="[`${name}__video`, `${name}__video--vimeo`]"
      @play="onShowContent(false)"
      @pause="onShowContent(true)"
      @ready="onEmbeddedVideoReady()"
    ></vimeo-player>
    <!-- Centered Play Icon Overlay -->
    <div v-if="showPlayIcon" class="play-icon" @click="togglePlay">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="150"
        height="150"
        viewBox="0 0 150 150"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M150 75C150 116.421 116.421 150 75 150C33.5786 150 0 116.421 0 75C0 33.5786 33.5786 0 75 0C116.421 0 150 33.5786 150 75ZM100.681 96.354C99.4207 96.354 97.9927 96.144 97.3627 95.892V92.532H97.5307C97.9507 92.784 98.9167 92.952 99.8827 92.952C101.437 92.952 102.445 92.364 103.243 90.222C103.243 90.1978 103.316 89.9714 103.418 89.6554L103.418 89.6546L103.418 89.6544L103.418 89.6542C103.671 88.8729 104.1 87.5453 104.041 87.366L95.4307 65.946H99.6727L104.335 78.462C105.259 81.024 106.225 84.552 106.225 84.552H106.309C106.309 84.552 107.359 80.982 108.241 78.462L112.735 65.946H116.809L107.233 90.558C105.385 95.304 103.579 96.354 100.681 96.354ZM73.6058 82.536C73.6058 86.862 76.9658 88.962 81.2498 88.962C85.0718 88.962 87.3818 87.156 88.8098 85.182H88.8518C89.2718 87.576 90.4478 88.71 92.8418 88.71C93.7658 88.71 94.3958 88.542 94.9418 88.374V85.644H94.7738C92.7998 86.064 92.3798 85.098 92.3798 83.292V72.75C92.3798 69.726 91.2458 67.752 89.3558 66.618C87.9278 65.778 86.0378 65.4 83.8958 65.4C77.8058 65.4 74.9078 68.802 74.7398 72.624H78.5198C78.6458 69.936 80.3678 68.256 83.9378 68.256C87.0458 68.256 88.7678 69.768 88.7678 72.204C88.7678 74.514 86.6258 75.06 83.3078 75.438C77.4698 76.152 73.6058 77.286 73.6058 82.536ZM88.8098 80.184C88.8098 82.788 86.7098 86.106 82.2158 86.106C79.9478 86.106 77.7218 85.392 77.7218 82.494C77.7218 79.386 80.1578 78.714 83.8538 78.084C85.7018 77.748 87.6758 77.202 88.8098 76.488V80.184ZM65.1402 88.5V57.252H69.0462V88.5H65.1402ZM38.3668 57.252V88.5H42.6928V75.648H51.0928C57.8548 75.648 61.2148 72.162 61.2148 66.408C61.2148 63.93 60.3748 61.914 58.9888 60.276C57.3928 58.344 54.8308 57.252 51.5128 57.252H38.3668ZM42.6928 72.162V60.99H50.8408C54.7048 60.99 56.9308 62.88 56.9308 66.534C56.9308 70.02 54.9148 72.162 50.6728 72.162H42.6928Z"
          fill="currentFill"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getIdFromURL } from 'vue-youtube-embed'
export default {
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      name: 'a-video',
      loaded: false,
      showPlayIcon: true,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'loading/isLoading',
    }),
    youTubeId() {
      return getIdFromURL((this.cms.youtube || {}).vimeo_raw) || ''
    },
    vimeoId() {
      return (this.cms.vimeo || {}).vimeo_raw || ''
    },
  },
  watch: {
    async loading(newValue) {
      if (newValue === false && this.loaded === false) {
        await this.$store.dispatch('loading/startBusyState')
      }
    },
  },
  async beforeCreate() {
    await this.$store.dispatch('loading/startBusyState')
  },
  methods: {
    async onEmbeddedVideoReady() {
      this.loaded = true
      await this.$store.dispatch('loading/stopBusyState')
    },
    async onVideoReady() {
      this.loaded = true
      await this.$store.dispatch('loading/stopBusyState')
    },
    onShowContent(boolean) {
      this.$emit('onShowContent', boolean)
    },
    togglePlay() {
      const video = this.$refs.videoPlayer
      if (video.paused) {
        video.play()
        this.showPlayIcon = false
      } else {
        video.pause()
        this.showPlayIcon = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.video-container {
  position: relative;
  display: inline-block;
  width: 100%;
}
video {
  display: block;
}

.play-icon {
  /* Center the icon absolutely */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  /* Make the icon clickable */
  cursor: pointer;

  /* Optionally size the icon container */
  width: 150px;
  height: 150px;

  svg {
    fill: white;
  }
}

.play-icon:hover {
  svg {
    fill: #ff3476;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.a-video {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;

  &__video {
    background: $black;
    display: block;
    object-fit: fill;
    position: absolute;
    min-width: 100%;
    min-height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ::v-deep &__video--youtube,
  ::v-deep &__video--vimeo {
    // padding-bottom: 56.25%; /* 16:9 */
    // height: 0;
    iframe {
      border: none;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}
</style>
